//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('factories', {
//        templateUrl: 'views/components/views/factories/factories.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'factoriesService', function (stateService, factoriesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListFactories: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadFactories() {
//                vm.model.itemsListFactories = (await factoriesService.listFactories());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'factory':
//                        go({ factory_id: '+' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadFactories();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
